import {
    formatCampaignListOxford,
    formatSurchargePercent,
    isPledgePayCreditCovered,
} from './pledge-pay-utils';
import { shouldSkipAmountToPayRowForStatement } from './pledge-pay-amount';
import { getPledgeRowAmountToPay } from './pay-pledge-map';
import { getPledgePaySurchargeAmt } from './pledge-pay-config';
import { isCheckCashPaymentKind, selectedPaymentKind } from '../shared/payment-kind.js';
import { formatCoverSurchargeAmountHint } from '../shared/cover-surcharge-hint';
import { mgrPledgeModalCollectGatewayCreditApply } from './pledge-pay-open-payment-gateway';

function pledgeRowCoversSurcharge($row, $root) {
    if (isCheckCashPaymentKind(selectedPaymentKind($root))) {
        return false;
    }
    const $section = $row.closest('.mgr-pledge-gateway-group');
    const $checkbox = $section.length
        ? $section.find('.mgr-gateway-cover-surcharge')
        : $root.find('#cover_surcharge');
    return Number($row.attr('data-force-surcharge')) === 1
        || ($checkbox.prop('checked') === true && !$checkbox.prop('disabled'));
}

function gatewaySurchargePrincipal($section, $root, appliedCredit) {
    const totals = { required: 0, optional: 0 };
    let creditRemaining = Math.max(0, Number(appliedCredit) || 0);
    $section.find('.sort_pledges tr').each(function () {
        const $row = $(this);
        if (shouldSkipAmountToPayRowForStatement($row, $root)
            || $row.find('input[name="amount_paid"]').prop('disabled')) {
            return;
        }
        const amount = Math.max(0, getPledgeRowAmountToPay($row) || 0);
        const credit = Math.min(creditRemaining, amount);
        creditRemaining = Math.round((creditRemaining - credit) * 100) / 100;
        const cardAmount = Math.round((amount - credit) * 100) / 100;
        if (Number($row.attr('data-force-surcharge')) === 1) {
            totals.required += cardAmount;
        } else {
            totals.optional += cardAmount;
        }
    });
    return totals;
}

function syncGatewaySurchargePanels($root) {
    const rate = getPledgePaySurchargeAmt();
    const cash = isCheckCashPaymentKind(selectedPaymentKind($root));
    const creditByGateway = mgrPledgeModalCollectGatewayCreditApply($root);
    const optionalAllowed = $root.find('#cover_surcharge').length > 0;
    let total = 0;
    $root.find('.mgr-pledge-gateway-group').each(function () {
        const $section = $(this);
        const principal = gatewaySurchargePrincipal($section, $root, creditByGateway[$section.attr('data-gateway-id')]);
        const requiredFee = Math.round(principal.required * rate * 100) / 100;
        const combinedFee = Math.round((principal.required + principal.optional) * rate * 100) / 100;
        const optionalFee = Math.round((combinedFee - requiredFee) * 100) / 100;
        const pending = $section.find('.matanah-save-btn').length > 0;
        const offered = !cash && rate > 0 && optionalAllowed && principal.optional > 0;
        const required = !cash && rate > 0 && requiredFee > 0;
        const $checkbox = $section.find('.mgr-gateway-cover-surcharge');
        const disabled = !offered || pending;
        $checkbox.prop('disabled', disabled);
        if (disabled) {
            $checkbox.prop('checked', false);
        }
        $section.find('.mgr-gateway-surcharge').prop('hidden', !offered && !required);
        $section.find('.mgr-gateway-surcharge-option').prop('hidden', !offered);
        $section.find('.mgr-gateway-surcharge-copy').text(`Cover the ${formatSurchargePercent()}% processing fee`);
        $section.find('.mgr-gateway-surcharge-hint').text(formatCoverSurchargeAmountHint(optionalFee));
        $section.find('.mgr-gateway-surcharge-required')
            .prop('hidden', !required)
            .text(`Required ${formatSurchargePercent()}% processing fee${formatCoverSurchargeAmountHint(requiredFee)}`);
        if (!cash && rate > 0) {
            total += $checkbox.prop('checked') ? combinedFee : requiredFee;
        }
    });
    return Math.round(total * 100) / 100;
}

function pledgeUpdateSurchargeSectionRowVisibility($container) {
    if ($container.find('.mgr-pledge-gateway-stack').length) {
        $container.find('#cover_surcharge_row').hide();
        return;
    }
    const $surchargeSectionRow = $container.find('#cover_surcharge_row');
    if (!$surchargeSectionRow.length) {
        return;
    }
    const requiredActive = !!$surchargeSectionRow.data('mgrRequiredSurchargeActive');
    const optionalActive = !!$surchargeSectionRow.data('mgrOptionalSurchargePanelActive');
    $container.find('#mgr_pledge_required_surcharge_panel, #force_surcharge_row').toggle(requiredActive);
    $container.find('#mgr_pledge_optional_surcharge_panel').toggle(optionalActive);
    if (!optionalActive) {
        $container.find('#cover_surcharge').prop('checked', false);
    }
    $surchargeSectionRow.toggle(requiredActive || optionalActive);
}

function applyCheckCashSurchargeLock($container) {
    const $cb = $container.find('#cover_surcharge');
    if (!$cb.length || !isCheckCashPaymentKind(selectedPaymentKind($container))) {
        return false;
    }
    $cb.prop({ checked: false, disabled: true });
    $cb.data('mgrSurchargeCashLock', true);
    $container.find('#mgr_pledge_optional_surcharge_panel').addClass('mgr-pledge-surcharge-panel--disabled');
    $container.find('#mgr_pledge_required_surcharge_panel, #force_surcharge_row').hide();
    return true;
}

function syncCoverSurchargeWithPaymentKind($container) {
    if ($container.find('.mgr-pledge-gateway-stack').length) {
        syncGatewaySurchargePanels($container);
        return;
    }
    const $cb = $container.find('#cover_surcharge');
    if (!$cb.length || applyCheckCashSurchargeLock($container)) {
        return;
    }
    if ($cb.data('mgrSurchargeCashLock') !== true) {
        return;
    }
    $cb.removeData('mgrSurchargeCashLock');
    if (isPledgePayCreditCovered($container) ||$cb.data('mgrSurchargeMatanahLock') === true) {
        return;
    }
    $cb.prop('disabled', false);
    $container.find('#mgr_pledge_optional_surcharge_panel').removeClass('mgr-pledge-surcharge-panel--disabled');
    pledgeUpdateSurchargeSectionRowVisibility($container);
}

function syncOptionalCoverSurchargeForCreditCover($container, creditFullyCoversOnlineDue) {
    if ($container.find('.mgr-pledge-gateway-stack').length) {
        syncGatewaySurchargePanels($container);
        return;
    }
    if (applyCheckCashSurchargeLock($container)) {
        return;
    }
    const $cb = $container.find('#cover_surcharge');
    if (!$cb.length) {
        return;
    }
    const $panel = $container.find('#mgr_pledge_optional_surcharge_panel');
    const matanahLocked = $cb.data('mgrSurchargeMatanahLock') === true;
    if (creditFullyCoversOnlineDue) {
        $cb.prop({ checked: false, disabled: true });
        $panel.addClass('mgr-pledge-surcharge-panel--disabled');
        return;
    }
    if (!matanahLocked) {
        $cb.prop('disabled', false);
    }
    $panel.removeClass('mgr-pledge-surcharge-panel--disabled');
}

function getSurchargePrincipalTotals($container) {
    const totals = {
        total: 0,
        forceTotal: 0,
        optionalTotal: 0,
    };

    const $rows = $container.find('.sort_pledges tr');
    if (!$rows.length) {
        return totals;
    }

    $rows.each(function () {
        const $row = $(this);
        if (shouldSkipAmountToPayRowForStatement($row, $container)) {
            return;
        }
        const amount = getPledgeRowAmountToPay($row);
        if (!amount) {
            return;
        }
        totals.total += amount;
        const forceFlag = String($row.data('force-surcharge')) === '1';
        if (forceFlag) {
            totals.forceTotal += amount;
        } else {
            totals.optionalTotal += amount;
        }
    });

    return totals;
}

function getForceSurchargeCampaigns($container, result = null) {
    if (result && Array.isArray(result.forceCampaignsArr) && result.forceCampaignsArr.length) {
        return [...new Set(result.forceCampaignsArr.filter(Boolean))];
    }

    const campaigns = [];
    $container.find('tbody tr').each(function () {
        const $row = $(this);
        if (shouldSkipAmountToPayRowForStatement($row, $container)) {
            return;
        }
        if (String($row.data('force-surcharge')) !== '1') {
            return;
        }
        const campaign = $row.data('campaign');
        if (campaign) {
            campaigns.push(campaign);
        }
    });

    return [...new Set(campaigns)];
}

function updateForceSurchargeRow($container, result = null) {
    const $coverRow = $container.find('#cover_surcharge_row');
    const $row = $container.find('#force_surcharge_row');
    if (!$row.length) {
        return;
    }

    const $requiredPanel = $container.find('#mgr_pledge_required_surcharge_panel');
    const campaigns = getForceSurchargeCampaigns($container, result);
    const $message = $container.find('#force_surcharge_message');
    const isMgrPledgeModal = $container.closest('#setPledgePaymentModal').length > 0;

    if (!campaigns.length) {
        $message.html('');
        $row.hide();
        if ($requiredPanel.length) {
            $requiredPanel.hide();
        }
        if ($coverRow.length) {
            $coverRow.data('mgrRequiredSurchargeActive', false);
        }
        pledgeUpdateSurchargeSectionRowVisibility($container);
        return;
    }

    const percent = formatSurchargePercent();
    const campaignText = isMgrPledgeModal ? formatCampaignListOxford(campaigns) : campaigns.join('/');
    $message.html(
        '<i class="fa-solid fa-triangle-exclamation fa-lg mgr-pledge-force-surcharge-icon" aria-hidden="true"></i>' +
            `<span>A ${percent}% processing fee will be added to ${campaignText} transactions</span>`
    );

    if ($coverRow.length) {
        $coverRow.data('mgrRequiredSurchargeActive', true);
    }
    pledgeUpdateSurchargeSectionRowVisibility($container);
}

function resetSurchargeRows($container) {
    $container.find('#force_surcharge_message, #surcharge_message').html('');
    $container.find(
        '#force_surcharge_row, #mgr_pledge_required_surcharge_panel, #mgr_pledge_optional_surcharge_panel, #cover_surcharge_row'
    ).hide();
    $container.find('#cover_surcharge_row')
        .removeData('mgrOptionalSurchargePanelActive')
        .removeData('mgrRequiredSurchargeActive');
}

function getSelectedPledgeSurchargeTotal($container, balanceApplied = 0) {
    if ($container.find('.mgr-pledge-gateway-stack').length) {
        return syncGatewaySurchargePanels($container);
    }
    if (isCheckCashPaymentKind(selectedPaymentKind($container))) {
        return 0;
    }
    const totals = getSurchargePrincipalTotals($container);
    const surchargeRate = getPledgePaySurchargeAmt();
    if (surchargeRate <= 0) {
        return 0;
    }
    const coverOptional = $container.find('#cover_surcharge').is(':checked');
    const eligiblePrincipal = totals.forceTotal + (coverOptional ? totals.optionalTotal : 0);
    const cardPrincipal = Math.max(0, totals.total - (parseFloat(balanceApplied) || 0));
    const surchargeBase = Math.min(eligiblePrincipal, cardPrincipal);
    return Math.round(surchargeBase * surchargeRate * 100) / 100;
}

export {
    getForceSurchargeCampaigns,
    getSelectedPledgeSurchargeTotal,
    getSurchargePrincipalTotals,
    pledgeUpdateSurchargeSectionRowVisibility,
    resetSurchargeRows,
    syncCoverSurchargeWithPaymentKind,
    syncOptionalCoverSurchargeForCreditCover,
    updateForceSurchargeRow,
    pledgeRowCoversSurcharge,
    syncGatewaySurchargePanels,
};
